import '../navigation/anchor';
import './pro-feature-summary.css';

const template = `
<db:profeaturesummary>
<table>
    <tr>
        <td colspan=2 style='text-align: center;'><b><u>Advanced Toolkit</u></b></td>
    </tr>
    <tr>
        <td style='width: 11rem;'><b>Suggest Cards</b></td>
        <td>Finds cards that may fit in a deck. Uses the existing
            card-tactic assignments to create weighted searches.
            Sorts results by best overall fit.
        </td>
    </tr>
    <tr>
        <td><b>Optimize 60+</b></td>
        <td>Searches for the best balance of existing-card quantities for a 60+
            card deck optimized for Success Rate, Land Pace,
            Power/Utility, and Card Diversity.
        </td>
    </tr>
    <tr>
        <td><b>Optimize 100+</b></td>
        <td>Searches for the best balance of existing-card quantities for a 100+
            card deck, following commander card uniquenss rules,
            optimized for Success Rate, Land Pace, Power/Utility,
            and Card Diversity.<br /><br />
            (This is only useful if the deck list has more individual
            "candidate" cards than are necessary for a 100+ card deck.)
        </td>
    </tr>
    <tr>
        <td><b>Auto-Build</b> (alpha)</td>
        <td>Given a small list of cards and assigned tactics, auto-build will automatically
            find and sort thousands of potential similar cards and optimize a deck in-place.
            <br /><br />
            This <b>alpha</b> feature is capable of creating finished decks consistent with
            player-provided themes. And, it's only getting better from here!
        </td>
    </tr>
    <tr>
        <td><b>Card Details+</b></td>
        <td>Adds a <u>Similar Cards</u> section to the card detail pages from the
            the <db:a href='?cards' body='Card Search'></db:a> results. Uses multi-feature
            fuzzy card searching.
        </td>
    </tr>
    <tr>
        <td colspan=2 style='text-align: center;'><b><u>Ultimate Toolkit</u></b></td>
    </tr>
    <tr>
        <td>*</td>
        <td>(Everything in the Advanced Toolkit.)</td>
    </tr>
    <tr>
        <td><b>Consult AI Agent</b> (beta)</td>
        <td>Sends all of a deck's info (including statistical analysis)
            to an LLM for assessment and guidance.
        </td>
    </tr>
</table>
</<db:profeaturesummary>`;

const ProFeatureSummary = DomClass(template);

export default ProFeatureSummary;
